/**
 * PURE: a page's suggestions placed by its fields (the Phase 2 pages are keyed by field id): each suggestion under
 * the first of its `field_ids` the page shows, in order; `unplaced` are the ones no field there shows (a detail
 * the page lists read-only, or not at all).
 */
export function placeSuggestions(suggestions, shownIds) {
    const shown = new Set(shownIds);
    const byField = new Map();
    const unplaced = [];
    for (const s of suggestions) {
        const id = s.field_ids.find((i) => shown.has(i));
        if (id === undefined)
            unplaced.push(s);
        else
            byField.set(id, [...(byField.get(id) ?? []), s]);
    }
    return { byField, unplaced };
}
/**
 * The state of one field on the agency's view of a row (spec 3.6 clientInfo):
 * - `talent_live`: the row follows the talent's value;
 * - `agency_value`: the agency holds its own value;
 * - `pending_with_talent`: an open suggestion waits for the talent;
 * - `talent_kept_theirs`: the talent answered the latest suggestion with Keep mine;
 * - `talent_updated`: the agency holds its own value while the talent's (visible, non-empty, not provisional)
 *   value differs and is newer (Use theirs?);
 * - `not_shared`: the agency asks for it and it is not visible to the row.
 */
export const CLIENT_FIELD_STATES = ['talent_live', 'agency_value', 'pending_with_talent', 'talent_kept_theirs', 'talent_updated', 'not_shared'];
/**
 * The keys a save refused as stale names (409 details: `[{ key }]`, from talent_agency_edit or a paused row's
 * check), else none.
 */
export function staleKeysOf(details) {
    if (!Array.isArray(details))
        return [];
    return details.map((d) => (d && typeof d === 'object' ? d.key : null)).filter((k) => typeof k === 'string');
}
// ── Phase 3: My info, Sharing, the to-do list, activity, asks, the picker's search, the gap-only prefill ──
/** How one of the talent's agencies holds a field (My info): following the talent, its own value, asked and not
 *  shared, paused (archived or left), sharing ended, or declined. */
export const FIELD_SHARE_STATES = ['live', 'agency_value', 'pending', 'paused', 'ended', 'declined'];
export const TODO_KINDS = ['ask', 'suggestion', 'quarantine', 'same_child', 'review_guardian_shared', 'conflict', 'quick_check', 'confirm_alias', 'vault_save'];
/** A work permit that needs attention (spec 3.18): expired, expiring within 30 days, or missing where one is required. */
export const PERMIT_WARNING_KINDS = ['expired', 'expiring', 'missing'];
//# sourceMappingURL=api.js.map